'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useFormContext } from 'react-hook-form';
import { Field } from '../../../auth/field';

export enum EducationLevels {
  HIGH_SCHOOL = 'high_school',
  UNIVERSITY_1 = 'university_1',
  UNIVERSITY_2 = 'university_2',
  UNIVERSITY_3 = 'university_3',
}

export const educationLevelsValues = [
  { label: 'text1777', value: EducationLevels.HIGH_SCHOOL },
  { label: 'text1778', value: EducationLevels.UNIVERSITY_1 },
  { label: 'text1779', value: EducationLevels.UNIVERSITY_2 },
  { label: 'text1780', value: EducationLevels.UNIVERSITY_3 },
];

export const AddOfferStep2 = () => {
  const { t } = useTranslations();
  const form = useFormContext();

  return (
    <div className="flex flex-col gap-6 bg-white p-6 md:gap-8 md:rounded-lg md:p-8">
      <h1 className="text-2xl font-bold md:text-4xl">{t('text1731')}</h1>
      <p className="text-[#63626F]">{t('text1771')}</p>

      <Field
        control={form.control}
        name="qualification"
        label={t('Požadované vzdelanie a kvalifikácia')}
        type="textarea"
      />
    </div>
  );
};
